/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

function DropdownMenu({ items }) {
  const [opened, setOpen] = useState(false);
  const menuListRef = useRef(null);

  function handleClickOutside(event) {
    if (menuListRef.current && !menuListRef.current.contains(event.target)) {
      setOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuListRef]);

  function handleClick() {
    setOpen(!opened);
  }

  function handleClickForItem(itemAction) {
    setOpen(false);
    itemAction();
  }

  return (
    <div className="dropdown-menu" ref={menuListRef}>
      <div className="dropdown-menu__opener" onClick={handleClick} />
      <div className={`dropdown-menu__list${opened ? ' opened' : ' hidden'}`}>
        <ul className="dropdown-menu__links">
          {items.map((item) => (
            <li className="dropdown-menu__link" key={item.text}>
              {item.to ? (
                <Link
                  to={item.to}
                  onClick={() => handleClickForItem(item.action)}
                >
                  {item.text}
                </Link>
              ) : (
                <a href="#" onClick={(e) => { e.preventDefault(); handleClickForItem(item.action)}}>
                  {item.text}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default DropdownMenu;
